import Annotation from "./annotation";
import { setLineStyle, setFontStyle } from "../canvasUtils";

export default class InnerChartSegmentationMeasurement extends Annotation {
  constructor() {
    super();

    this.transform = null;
    this.sliceInfo = null;
    this.measureData = null;
    this.maxX = null;
    this.xInPerPx = 0;
    this.yInPerPx = 0;
    this.mmPerIn = 25.4;
    this.umPerMm = 1000;

    this.color = "#00b0f0";
    this.font = "14px Calibri";
    this.baseline = "hanging";

    this.triangleLength = 5;

    this.canvasSize = null;
  }

  draw(ctx) {
    if (!this.measureData || !this.transform || !this.sliceInfo || !this.canvasSize) return;

    let w = this.canvasSize.w;
    let h = this.canvasSize.h;

    let chartW = w;
    let x = this.convertX(chartW, this.measureData.index);

    setLineStyle(ctx, this);
    this.drawSlider(ctx, x);

    if (!this.measureData.thickness) return;

    let chartH = h;
    let y = this.convertY(chartH, this.measureData.thickness);
    this.drawHelperLine(ctx, x, y);
    this.drawThicknessLine(ctx, x, y, chartH);

    let text = this.measureData.thicknessText;
    this.drawText(ctx, x, y, chartH, chartW, text);
  }

  drawSlider(ctx, x){
    ctx.beginPath();
    ctx.moveTo(x, this.triangleLength);
    ctx.lineTo(x - this.triangleLength, 0);
    ctx.lineTo(x + this.triangleLength, 0);
    ctx.lineTo(x, this.triangleLength);
    ctx.closePath();
    ctx.stroke();
    ctx.fill();
  }

  drawHelperLine(ctx, x, y){
    ctx.setLineDash([3, 10]);
    ctx.beginPath();
    ctx.moveTo(x, 0);
    ctx.lineTo(x, y - 10);
    ctx.stroke();
    ctx.closePath();
    ctx.setLineDash([]);
  }

  drawThicknessLine(ctx, x, y, chartH){
    ctx.beginPath();
    ctx.moveTo(x, y);
    ctx.lineTo(x, chartH);
    ctx.closePath();
    ctx.stroke();
  }

  drawText(ctx, x, y, chartH, chartW, text){
    setFontStyle(ctx, this);
    let textY = (chartH + y) / 2 - 7;
    let textWidth = ctx.measureText(text).width;
    let textX = x + 5;
    if (chartW < x + textWidth + 5) textX = x - textWidth - 5;
    ctx.fillText(text, textX, textY);
  }

  convertX(chartW, x) {
    let fitZoom = this.transform.fitZoom;
    let zoom = this.transform.zoom;
    let offsetX = this.transform.offsetX;

    return x * (chartW * zoom  * this.xInPerPx * this.mmPerIn) / (this.maxX * fitZoom) + offsetX;
  }

  convertY(chartH, y) {
    return chartH * (1 - y * this.yInPerPx * this.mmPerIn * this.umPerMm / 1000);
  }

  updateTransform(transform) {
    if (this.transform !== transform) this.transform = transform;
    this.signalReady();
  }

  updateSliceInfo(sliceInfo) {
    if (this.sliceInfo !== sliceInfo) this.sliceInfo = sliceInfo;
    if (this.sliceInfo) {
      this.xInPerPx = 1 / this.sliceInfo.dimensions.horizontalResolution;
      this.yInPerPx = 1 / this.sliceInfo.dimensions.verticalResolution;

      let pxWidth = this.sliceInfo.segmentation.originalPixelWidth;
      let xPxPerMm = this.sliceInfo.dimensions.horizontalResolution / this.mmPerIn;
      this.maxX = pxWidth / xPxPerMm;
    }
    this.signalReady();
  }

  updateMeasureData(data) {
    if (this.measureData !== data) this.measureData = data;
    this.signalReady();
  }
}

